/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PreviousPaxOrderByType = {
    UsageCount: 'UsageCount',
    NewestFirst: 'NewestFirst'
} as const;

export type PreviousPaxOrderByType = typeof PreviousPaxOrderByType[keyof typeof PreviousPaxOrderByType];



